import Hash from './hash';

export default Hash;
